import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHelmet from '@/components/base/SEOHelmet';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotSection from './components/HotSection';
import LatestSection from './components/LatestSection';
import RecommendedSection from './components/RecommendedSection';

export default function Home() {
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '55漫画网',
      url: 'http://junyitea.cn/',
      description: '55漫画网提供韩漫全集免费阅读，海量韩国漫画、日本漫画、国产漫画资源，无需付费即可观看全部内容。',
      sameAs: ['http://junyitea.cn/', 'http://junyitea.cn/55manhua'],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '55漫画网',
      url: 'http://junyitea.cn/',
      description: '家教老师漫画-韩漫全集免费阅读-55漫画网，体验地道的韩国漫画风格，使用用户友好界面轻松浏览。',
      potentialAction: {
        '@type': 'SearchAction',
        'target': {
          '@type': 'EntryPoint',
          urlTemplate: 'http://junyitea.cn/search?q={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '55漫画网 - 韩漫全集免费阅读',
      description: '在55漫画网可以免费阅读家教老师漫画的韩漫全集，体验地道的韩国漫画风格，使用用户友好界面轻松浏览，无需付费即可观看全部内容。',
      url: 'http://junyitea.cn/',
      isPartOf: {
        '@type': 'WebSite',
        name: '55漫画网',
        url: 'http://junyitea.cn/',
      },
    },
  ];

  return (
    <>
      <SEOHelmet
        title="家教老师漫画-韩漫全集免费阅读-55漫画网"
        description="在55漫画网可以免费阅读家教老师漫画的韩漫全集，体验地道的韩国漫画风格，使用用户友好界面轻松浏览，无需付费即可观看全部内容。"
        keywords="家教老师漫画, 韩漫, 免费阅读, 漫画全集, 55漫画网"
        canonicalUrl="http://junyitea.cn/"
        ogImage="https://readdy.ai/api/search-image?query=55manhua%20Korean%20webtoon%20reading%20platform%20homepage%20with%20popular%20manhwa%20covers%2C%20warm%20color%20palette%2C%20clean%20modern%20design%2C%20digital%20reading%20platform%20theme&width=1200&height=630&seq=home-og-001&orientation=landscape"
        jsonLd={jsonLd}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <HotSection />
        <LatestSection />
        <RecommendedSection />

        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="bg-accent-100/70 rounded-2xl p-8 md:p-12">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                <div>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                    随时随地，畅享阅读
                  </h2>
                  <p className="text-foreground-600 text-sm leading-relaxed mb-6">
                    55漫画网致力于为漫画爱好者提供最优质的阅读体验。高清画质、极速加载、智能推荐，让你沉浸在漫画的精彩世界中。
                  </p>
                  <div className="flex flex-wrap gap-3">
                    <span className="px-4 py-2 rounded-full bg-background-50 text-foreground-700 text-sm whitespace-nowrap">
                      <strong>500+</strong> 精选作品
                    </span>
                    <span className="px-4 py-2 rounded-full bg-background-50 text-foreground-700 text-sm whitespace-nowrap">
                      <strong>100%</strong> 免费阅读
                    </span>
                    <span className="px-4 py-2 rounded-full bg-background-50 text-foreground-700 text-sm whitespace-nowrap">
                      <strong>每日</strong> 更新
                    </span>
                  </div>
                </div>
                <div className="hidden md:block">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20cozy%20reading%20scene%20with%20a%20tablet%20displaying%20Korean%20webtoon%20art%2C%20warm%20ambient%20lighting%2C%20coffee%20cup%20nearby%2C%20comfortable%20modern%20setting%2C%20Korean%20lifestyle%20aesthetic%2C%20soft%20natural%20light%2C%20clean%20composition&width=600&height=400&seq=home-reading-001&orientation=landscape"
                    alt="随时随地畅享漫画阅读体验"
                    title="55漫画网 - 随时随地畅享阅读"
                    className="rounded-lg w-full h-auto"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                常见问题
              </h2>
              <p className="text-sm text-foreground-500">关于55漫画网，你可能想知道的事</p>
            </div>
            <div className="max-w-3xl mx-auto space-y-3">
              {[
                { q: '55漫画网上的漫画真的免费吗？', a: '是的！55漫画网所有漫画资源完全免费，无需注册会员，无需付费订阅，打开即可畅享全部内容。我们通过广告收入维持运营，为用户提供免费的阅读体验。' },
                { q: '支持哪些类型的漫画？', a: '我们提供韩漫、日漫、国漫、美漫、耽美等多种类型的漫画资源，涵盖恋爱、热血、悬疑、奇幻、校园、都市等各种题材，满足不同读者的喜好。' },
                { q: '如何在手机上阅读？', a: '55漫画网采用响应式设计，在手机、平板和电脑上都能获得流畅的阅读体验。无需下载App，直接在浏览器中打开即可，支持添加到手机主屏幕，像App一样便捷。' },
              ].map((faq, i) => (
                <details key={i} className="group bg-background-50 rounded-lg p-5 cursor-pointer">
                  <summary className="text-sm font-medium text-foreground-900 flex items-center justify-between">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}